import axios from "axios";
import GetServerAddress from "../../../../functions/GetServerAddress";

export function Send_SEF_Emails(customer, newNote, logout) {
  const postData = async () => {
    try {
      const response = await axios.post(
        GetServerAddress() + "api/staff/Send_SEF_Emails",
        {
          customer: customer,
          newNote: newNote,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Token")}`, // Include the JWT token in the request headers
            username: localStorage.getItem("Username"),
            activitylog: "Yes",
            aboutid: customer._id,
          },
        }
      );
      console.log("Response Data: ", response);
      // Check for specific server response indicating an invalid auth token
      if (response.data.status === 403 || response.data.status === 401) {
        logout();
        return; // Stop further execution in case of invalid auth token
      }
      // Alert for successful POST request
    } catch (error) {
      console.error("Error Posting data: ", error);
      // Alert for failed POST request
      window.alert(
        "Error Posting data, please speak to Admin if this issue persists: ",
        error
      );
    }
  };
  postData();
} // Empty dependency array means this effect runs only once
